
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"222.602","height":"302.367","viewBox":"0 0 222.602 302.367"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 29867","d":"M74.637 288.023a15 15 0 019.959-18.73A105.14 105.14 0 0023.116 68.2a15 15 0 01-8.772-28.689c71.261-21.787 146.96 18.464 168.746 89.724s-18.463 146.96-89.723 168.746a15 15 0 01-18.73-9.958z","fill":"#fff"}})])
          )
        }
      }
    